import { z } from 'zod';
// ============================================================
// Constants
// ============================================================
/** 랜덤 블록 선택용 특수 slug — 백엔드에서 활성 블록 중 랜덤 치환 */
export const RANDOM_BLOCK_SLUG = 'RANDOM';
// ============================================================
// Prompt Block Schemas
// ============================================================
export const PromptBlockSchema = z.object({
    id: z.string(),
    slug: z.string().max(64),
    nameKo: z.string().max(128),
    nameEn: z.string().max(128),
    promptText: z.string(),
    imageUrl: z.string().nullable().optional(),
    isBuiltin: z.boolean(),
    isActive: z.boolean(),
    sortOrder: z.number().int(),
    tags: z.array(z.string()).default([]),
    createdAt: z.string().or(z.date()),
    updatedAt: z.string().or(z.date()),
});
/** 컨셉 블록 선택 (1블록 = 1컨셉, 또는 여러 블록 = 각 컨셉당 1장 일괄) */
export const ConceptSelectionSchema = z
    .object({
    conceptSlug: z.string().optional(),
    conceptSlugs: z.array(z.string().min(1)).min(1).max(10).optional(),
})
    .refine((v) => !!v.conceptSlug || (v.conceptSlugs?.length ?? 0) > 0, {
    message: 'conceptSlug 또는 conceptSlugs 중 하나는 필요합니다',
});
/** @deprecated ConceptSelectionSchema 사용 권장 */
export const PromptBlockSelectionSchema = ConceptSelectionSchema;
// ============================================================
// API Request/Response Schemas
// ============================================================
/** 태그 한 개 — 공백 trim 가정, 비빈 문자열, 길이 제한 */
const TagSchema = z.string().min(1).max(32);
/** 태그 배열 — 최대 20개, 중복 제거는 호출 측에서 보장 권장 */
const TagsArraySchema = z.array(TagSchema).max(20);
export const CreatePromptBlockSchema = z.object({
    slug: z.string().min(1).max(64).regex(/^[A-Z0-9_]+$/, 'slug은 대문자 영숫자 + 언더스코어만 허용')
        .refine(slug => slug !== 'RANDOM', { message: 'RANDOM은 예약어로 사용할 수 없습니다' }),
    nameKo: z.string().min(1).max(128),
    nameEn: z.string().min(1).max(128),
    promptText: z.string().min(1),
    imageUrl: z.string().optional(),
    isActive: z.boolean().optional(),
    sortOrder: z.number().int().optional(),
    tags: TagsArraySchema.optional(),
});
export const UpdatePromptBlockSchema = z.object({
    nameKo: z.string().min(1).max(128).optional(),
    nameEn: z.string().min(1).max(128).optional(),
    promptText: z.string().min(1).optional(),
    imageUrl: z.string().nullable().optional(),
    isActive: z.boolean().optional(),
    sortOrder: z.number().int().optional(),
    tags: TagsArraySchema.optional(),
});
export const PromptBlockListResponseSchema = z.object({
    blocks: z.array(PromptBlockSchema),
});
/** 유저 앱용 프롬프트 블록 요약 (promptText/isBuiltin 제외, isFavorited 포함) */
export const PromptBlockSummarySchema = z.object({
    id: z.string(),
    slug: z.string(),
    nameKo: z.string(),
    nameEn: z.string(),
    imageUrl: z.string().nullable(),
    thumbnailUrl: z.string().nullable(),
    sortOrder: z.number().int(),
    isFavorited: z.boolean(),
    tags: z.array(z.string()).default([]),
});
/** 프롬프트 블록 즐겨찾기 토글 요청 */
export const TogglePromptBlockFavoriteSchema = z.object({
    isFavorited: z.boolean(),
});
//# sourceMappingURL=prompt-blocks.js.map